import { Camera, CameraGroup } from '@/api';
import TimelineChunks from '@/components/video-player/objects/vms/chunks';
import { dataModule } from '@/store/data';

export default class VideoPlayerState {
  resolution = localStorage.getItem('video_player_resolution') || '1920x1080';

  videoQuality = 80;
  brightness = 50;
  contrast = 50;
  saturation = 50;
  bboxObjects = { faces: true, bodies: true, cars: true };

  // canChangeQuality = true;
  canChangeObjects = true;

  timelineChunks = new TimelineChunks();

  cameraId = -1;
  model = ''; // cameras | videos
  streamProps: any = {};

  camera: Camera | undefined;
  cameraGroup: CameraGroup | undefined;

  onWsOpened: any = null;

  get cameraName() {
    return (this.camera && this.camera.name) || '[Camera not found]';
  }

  get cameraGroupName() {
    return (this.cameraGroup && this.cameraGroup.name) || '[Group not found]';
  }

  get isOnvifCamera() {
    return this.camera?.onvif_camera !== null;
  }

  get isCameraRemoved() {
    return !(this.camera && this.camera.name) && this.model !== 'videos';
  }

  async fillCameraInfoById() {
    if (this.camera || this.cameraId === -1) {
      return;
    }
    this.camera = await dataModule.camerasModule.getById(this.cameraId);
    this.cameraGroup = undefined;
    if (this.camera) {
      this.cameraGroup = await dataModule.cameraGroupsModule.getById(this.camera.group);
    }
  }

  isTimeInChunks(time: number) {
    return this.timelineChunks.items.reduce((value, item) => {
      return value || (time > item.timeFrom && time < item.timeTo);
    }, false);
  }
}
